import { ValueType } from '@srm/ui/types/ValueType';
import { getRequiredMessage, type RequiredControlType } from '@srm/ui/lib/requiredMessage';

export type RequiredDocumentControl = 'field' | 'dict' | 'abook' | 'autoComplete' | 'calc';

export interface IRequiredMessageField {
    requiredMessage?: string | null;
    valueType?: ValueType;
    inputType?: string;
    trueText?: string;
    falseText?: string;
    isMultiple?: boolean;
}

const VALUE_TYPES: Partial<Record<ValueType, RequiredControlType>> = {
    [ValueType.Integer]: 'number',
    [ValueType.Double]: 'number',
    [ValueType.Money]: 'money',
    [ValueType.Date]: 'date',
    [ValueType.DateTime]: 'dateTime',
    [ValueType.NoSecDateTime]: 'dateTime',
    [ValueType.Time]: 'time',
    [ValueType.Year]: 'year',
    [ValueType.YesNo]: 'yesNo',
    [ValueType.Boolean]: 'checkbox',
    [ValueType.AddressBook]: 'select',
    [ValueType.Flow]: 'select',
};

export const getDocumentRequiredMessage = (
    field: IRequiredMessageField,
    controlType: RequiredDocumentControl = 'field',
): string => {
    let type: RequiredControlType = VALUE_TYPES[field.valueType ?? ValueType.Unknown] ?? 'text';
    if (controlType === 'dict' || controlType === 'abook') {
        type = field.isMultiple ? 'multiple' : 'select';
    } else if (controlType === 'calc') {
        type = field.valueType === ValueType.Money ? 'money' : 'number';
    } else if (field.inputType === 'rating') {
        type = 'rating';
    } else if (
        field.valueType === ValueType.YesNo &&
        ((field.trueText != null && field.trueText !== 'Да') || (field.falseText != null && field.falseText !== 'Нет'))
    ) {
        type = 'choice';
    }
    return getRequiredMessage(type, field.requiredMessage);
};
